import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';

declare var google: any;

declare global {
  interface Window {
    initMap: () => void;
  }
}

@Component({
  selector: 'app-mapa-rota-onibus',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './mapa-rota-onibus.component.html',
  styleUrls: ['./mapa-rota-onibus.component.scss']
})
export class MapaRotaOnibusComponent implements OnInit {
  @Input() locations!: { latitude: number, longitude: number }[];
  public map!: any;
  // public loading: boolean = true;

  constructor() { }

  ngOnInit(): void {
    // Verifique se as localizações foram passadas
    if (!this.locations || this.locations.length === 0) {
      // Defina uma localização fake
      this.locations = [
        { latitude: -23.5505, longitude: -46.6333 }, // São Paulo
      ];
    }

    window['initMap'] = () => this.initMap();
    this.loadGoogleMaps();
  }
  
  resetMap(): void {
    // this.loading = true;
    this.initMap();
  }

  loadGoogleMaps(): void {
    const script = document.createElement('script');
    script.src = `https://maps.gomaps.pro/maps/api/js?key=AlzaSyQfQK4n62N1wrZrKtZwH1eUQ-pkxrTeV3u&libraries=geometry,places&callback=initMap`;
    script.async = true;
    script.defer = true;
    document.head.appendChild(script);
  }

  initMap(): void {
    if (!this.locations || this.locations.length === 0) {
      console.error('Nenhuma localização fornecida');
      return; // Impede a execução se não houver locais
    }

    const initialLocation = this.locations[0];

    this.map = new google.maps.Map(document.getElementById('map'), {
      center: { lat: initialLocation.latitude, lng: initialLocation.longitude },
      zoom: 12,
    });

    this.locations.forEach(location => {
      new google.maps.Marker({
        position: { lat: location.latitude, lng: location.longitude },
        map: this.map,
        icon: {
          url: '../../../assets/svg/marcador.svg',
          scaledSize: new google.maps.Size(30, 30),
        }
      });
    });

    this.addRouteToSantoAndre();
    // this.loading = false;
  }

  addRouteToSantoAndre() {
    const santoAndreLocation: { lat: number, lng: number } = { lat: -23.6555, lng: -46.5323 };

    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(position => {
        const userLocation = { lat: position.coords.latitude, lng: position.coords.longitude };

        new google.maps.Marker({
          position: userLocation,
          map: this.map,
          icon: {
            url: '../../../assets/svg/my-location.svg',
            scaledSize: new google.maps.Size(30, 30),
          }
        });

        const directionsService = new google.maps.DirectionsService();
        const directionsRenderer = new google.maps.DirectionsRenderer();
        directionsRenderer.setMap(this.map);

        const request = {
          origin: userLocation,
          destination: santoAndreLocation,
          travelMode: google.maps.TravelMode.DRIVING,
        };

        directionsService.route(request, (result: any, status: any) => {
          if (status === google.maps.DirectionsStatus.OK) {
            directionsRenderer.setDirections(result);
          } else {
            console.error('Erro ao obter a rota:', status);
          }
        });
      }, error => {
        console.error('Erro ao obter localização do usuário:', error);
      });
    } else {
      console.error('Geolocalização não é suportada pelo navegador.');
    }
  }
}
